export default function () {
  return {
    state: {
      isCollapse: false,
      showTip: false,
      typeDatas: [
      ]
    },
    getters: {
      isCollapse: state => state.isCollapse,
      showTip: state => state.showTip,
      typeDatas: state => state.typeDatas
    },
    actions: {
      CHANGE_COLL({ commit }, isCollapse) {
        commit('CHANGE_COLL', isCollapse);
      },
      CHANGE_TIP({ commit }, showTip) {
        commit('CHANGE_TIP', showTip);
      }
    },
    mutations: {
      CHANGE_COLL(state, isCollapse) {
        state.isCollapse = isCollapse;
      },
      CHANGE_TIP(state, showTip) {
        state.showTip = showTip;
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/app/store.js